import { getColor } from 'helpers';
import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { ColorsDark, ColorsLight } from 'libs/ui/theme';

export const DialogDocumentsStyled = styled(Stack)(({ theme }) => ({
  padding: 12,
  borderRadius: 12,
  background: getColor(theme, {
    dark: ColorsDark.gray50,
    light: ColorsLight.gray50,
  }),
  marginBottom: 16,
  [theme.breakpoints.down('mobile')]: {
    marginBottom: 12,
  },
}));
